var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpansionPanelDetails = void 0;
var ExpansionPanelDetails_1 = __importDefault(require("./ExpansionPanelDetails"));
exports.ExpansionPanelDetails = ExpansionPanelDetails_1.default;
exports.default = ExpansionPanelDetails_1.default;
//# sourceMappingURL=index.js.map